import { compose, ifElse, assoc, always, prop } from 'ramda'

const getRenamedAd = (from, to, ads) => compose(
  ifElse(Boolean, assoc('component', to), always(undefined)),
  prop(from)
)(ads)

export { getRenamedAd }
